import { useState, useEffect } from 'react'
import ThankYou from '@/pages/ThankYou'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Services from '@/pages/Services'
import Reviews from '@/pages/Testimonials'
import Estimate from '@/pages/Estimate'
import FenceEstimate from '@/pages/FenceEstimate'
import Appointment from '@/pages/Appointment'
import ContactUs from '@/pages/Contact'
import { MobileFloatingButtons } from '@/components/MobileFloatingButtons'

// Import service pages
import Decks from '@/pages/services/decks'
import Pergolas from '@/pages/services/pergolas-and-privacy-walls'
import Gazebo from '@/pages/services/gazebo' 
import LivingSpaces from '@/pages/services/living-spaces'
import Railings from '@/pages/services/railings'
import Fences from '@/pages/services/fences'
import Landscaping from '@/pages/services/landscaping'

// Import blog pages
import BlogIndex from '@/pages/blog/index' 
import BlogPost1 from '@/pages/blog/1'
import BlogPost2 from '@/pages/blog/2'
import BlogPost3 from '@/pages/blog/3'
import BlogPost4 from '@/pages/blog/4' 
import BlogPost5 from '@/pages/blog/5' 
import BlogPostCopy from '@/pages/blog/best-decking-material-calgary-winters'
import BlogPostFenceCosts from '@/pages/blog/fence-installation-costs-calgary'
import TypesOfDecksBlog from '@/pages/blog/types-of-decks-calgary'
import DeckReplacementBlog from '@/pages/blog/deck-repair-vs-replacement-calgary'
import TimbertechVsTrexBlog from '@/pages/blog/timbertech-vs-trex-calgary'
import CalgaryDeckMaintenanceBlog from '@/pages/blog/calgary-deck-maintenance-checklist'
import BestTimeToBuildDeckCalgary from '@/pages/blog/best-time-to-build-deck-calgary'
import RemodelDeckCalgaryBlog from '@/pages/blog/remodel-deck-calgary'
import HiringCalgaryContractorBlog from '@/pages/blog/questions-to-ask-hiring-calgary-deck-contractor'
import AffordableFenceIdeasBlog from '@/pages/blog/affordable-fence-ideas'
import DeckHotTubStructuralReality from '@/pages/blog/can-your-deck-support-hot-tub'
import BlogPostPergolaPermit2 from '@/pages/blog/calgary-pergola-permit'

function App() {
  const [currentPath, setCurrentPath] = useState('/')
  
  // Helper to normalize paths by stripping trailing slashes to guarantee exact matches
  const normalizePath = (path: string) => {
    if (path.length > 1 && path.endsWith('/')) {
      return path.slice(0, -1)
    }
    return path
  }
  
  useEffect(() => {
    setCurrentPath(normalizePath(window.location.pathname))
    
    const handlePathChange = () => {
      setCurrentPath(normalizePath(window.location.pathname))
      window.scrollTo(0, 0)
    }
    
    window.addEventListener('popstate', handlePathChange)
    return () => {
      window.removeEventListener('popstate', handlePathChange)
    }
  }, [])
  
  const renderContent = () => {
    switch(currentPath) {
      case '':
      case '/': return <Home />
      case '/about-us': return <About />
      case '/services': return <Services />
      case '/testimonials': return <Reviews />
      case '/estimate': return <Estimate />
      case '/fence-estimate': return <FenceEstimate />
      case '/appointment': return <Appointment />
      case '/contact': return <ContactUs />
      
      // Services routes
      case '/services/decks': return <Decks />
      case '/services/pergolas-and-privacy-walls': return <Pergolas />
      case '/services/gazebo': return <Gazebo /> 
      case '/services/living-spaces': return <LivingSpaces />
      case '/services/railings': return <Railings />
      case '/services/fences': return <Fences />
      case '/services/landscaping': return <Landscaping />
      
      // Blog routes
      case '/blog': return <BlogIndex />
      case '/blog/1': return <BlogPost1 />
      case '/blog/2': return <BlogPost2 />
      case '/blog/3': return <BlogPost3 />
      case '/blog/4': return <BlogPost4 />
      case '/blog/5': return <BlogPost5 />
      case '/blog/best-decking-material-calgary-winters': return <BlogPostCopy />
      case '/blog/fence-installation-costs-calgary': return <BlogPostFenceCosts />
      case '/blog/types-of-decks-calgary': return <TypesOfDecksBlog />
      case '/blog/deck-replacement-vs-repair-calgary': return <DeckReplacementBlog />
      case '/blog/timbertech-vs-trex-calgary': return <TimbertechVsTrexBlog />
      case '/blog/calgary-deck-maintenance-checklist': return <CalgaryDeckMaintenanceBlog />
      case '/blog/best-time-to-build-deck-calgary': return <BestTimeToBuildDeckCalgary />
      case '/blog/remodel-deck-calgary': return <RemodelDeckCalgaryBlog />
      case '/blog/questions-to-ask-hiring-calgary-deck-contractor': return <HiringCalgaryContractorBlog />
      case '/blog/affordable-fence-ideas': return <AffordableFenceIdeasBlog />
      case '/blog/can-your-deck-support-hot-tub': return <DeckHotTubStructuralReality />
      case '/blog/calgary-pergola-permit': return <BlogPostPergolaPermit2 />
      case '/thank-you': return <ThankYou />
      default: return <Home />
    }
  }
  
  return (
    <div className="pb-16 md:pb-0">
      {renderContent()}
      <MobileFloatingButtons />
    </div>
  )
}

export default App